export enum CollectionPage {
  List = 'list',
  Edit = 'edit',
  Create = 'create',
  EditMerchRules = 'edit merch rules',
  EditRanking = 'edit ranking',
}
